import type {
  AgenticClientListItem,
  AgenticClientUpdateRequest,
  McpServer,
} from "@p0security/integrations-agentic-shared/interface";
import { Alert, Button } from "@p0security/ui";
import { useOutletContext } from "react-router-dom";

import type {
  AgenticClientRegistration,
  AgenticRegisteredClient,
} from "../types";

/** Data and handlers the overview layout shares with its tab routes. */
export type AgenticOverviewProps = {
  canManageServers: boolean;
  canRegisterClients: boolean;
  clientUpdateError?: string;
  isRegistering: boolean;
  isUpdatingClient: boolean;
  onClearClientUpdateError: () => void;
  onClearRegistrationError: () => void;
  onRefreshServers: () => void;
  onRegister: (
    registration: AgenticClientRegistration
  ) => Promise<AgenticRegisteredClient | undefined>;
  onUpdateClient: (
    clientId: string,
    metadata: AgenticClientUpdateRequest
  ) => Promise<AgenticClientListItem | undefined>;
  registrationError?: string;
  servers: McpServer[];
  serversError?: string;
  serversLoading: boolean;
};

/** The overview passes its props to the tab routes through the outlet. */
export const useAgenticContext = () => useOutletContext<AgenticOverviewProps>();

export const matchesSearch = (
  search: string,
  values: (string | undefined)[]
) => {
  const query = search.trim().toLowerCase();
  return (
    query.length === 0 ||
    values.some((value) => value?.toLowerCase().includes(query))
  );
};

export const ErrorAlert: React.FC<{
  messageText: string;
  onRetry: () => void;
}> = ({ messageText, onRetry }) => (
  <Alert
    action={
      <Button size="small" onClick={onRetry}>
        Try again
      </Button>
    }
    message={messageText}
    showIcon
    type="error"
  />
);
